var map = {
	"./bin.en.json": [
		1008,
		6295
	],
	"./bin.fr.json": [
		8357,
		9932
	],
	"./businesses.en.json": [
		7460,
		7885
	],
	"./businesses.fr.json": [
		7467,
		9553
	],
	"./decisions.en.json": [
		6976,
		3299
	],
	"./decisions.fr.json": [
		7070,
		9992
	],
	"./discounts.en.json": [
		4826,
		894
	],
	"./discounts.fr.json": [
		3588,
		9924
	],
	"./errors.en.json": [
		948
	],
	"./errors.fr.json": [
		9750,
		8402
	],
	"./jx-sanctions.en.json": [
		1513,
		2092
	],
	"./jx-sanctions.fr.json": [
		3519,
		408
	],
	"./lists-management.en.json": [
		7532,
		7665
	],
	"./lists-management.fr.json": [
		4745,
		5997
	],
	"./manual-withdrawals.en.json": [
		4302,
		7459
	],
	"./manual-withdrawals.fr.json": [
		8026,
		3407
	],
	"./operating-accounts.en.json": [
		7244,
		745
	],
	"./operating-accounts.fr.json": [
		6388,
		8975
	],
	"./purchases.en.json": [
		6664,
		9678
	],
	"./purchases.fr.json": [
		4637,
		2057
	],
	"./requests-management.en.json": [
		8932,
		5041
	],
	"./requests-management.fr.json": [
		624,
		243
	],
	"./settlement-by-bank.en.json": [
		8032,
		4565
	],
	"./settlement-by-bank.fr.json": [
		7547,
		3886
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4045;
module.exports = webpackAsyncContext;